import { ExtraOptionsKeys, MethodOfEnergyGeneration, PowerRequirements } from "./index250.js";
const defaultTechPresetValues = {
	energyGeneration: MethodOfEnergyGeneration.AmbientLoop,
	powerRequirements: PowerRequirements.PLVandSecondary,
	extraOptions: {
		[ExtraOptionsKeys.Sprinklers]: true,
		[ExtraOptionsKeys.ElectricalSubstation]: false,
		[ExtraOptionsKeys.Rainwater]: false,
		[ExtraOptionsKeys.Greywater]: false,
		[ExtraOptionsKeys.ExternalGenerator]: true
	}
};
export { defaultTechPresetValues };

//# sourceMappingURL=index251.js.map